import { Button, Card, Col, Modal, Popconfirm, Row, Typography, message } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import HTTPClient from "../../utils/HTTPClient";
import numeral from "numeral";
import { useTranslation } from "react-i18next";

const AvailableVersions = ({ userApp }) => {
    const [versions, setVersions] = useState([]);
    const [actualVersion, setActualVersion] = useState(false);
    const [open, setOpen] = useState(false);
    const [newVersion, setNewVersion] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        const fetch = async () => {
            HTTPClient.get("/app/_app_typologies")
                .then(async (res) => {
                    const present = res.data.find((a) => a.value === userApp.technology);
                    const resources = present.resources;
                    setActualVersion(resources.find((a) => a.value === userApp.resource_id));
                    setVersions(resources);
                })
                .catch((e) => {
                    return;
                });
        };
        fetch();
    }, []);
    if (!versions || !versions.length) return;

    const changeAppVersion = async () => {
        message.info(t("dettaglio_app.initial_page.changing_version"));
        setOpen(!open);
        return;
    };

    return (
        <>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Col xs={24} sm={24} lg={8} xl={8} style={{ padding: "10px" }}>
                    <Card
                        style={{
                            backgroundColor: "#5f4dee",
                            color: "#fafafa",
                            textAlign: "center",
                        }}>
                        <b> {actualVersion?.label}</b>
                        <br />
                        {t(`apps.${userApp.technology}.resources.${actualVersion?.value}`)}
                        <br />€
                        {numeral(actualVersion?.price / 100).format("0,0.00") +
                            ` (1 ${t("create_app.month")})`}
                    </Card>
                </Col>
            </Row>
            {versions.length > 1 && (
                <Row style={{ width: "100%" }}>
                    <Col xs={24} sm={24} lg={8} xl={8} style={{ padding: "10px" }}>
                        <Button type="primary" onClick={() => setOpen(!open)}>
                            {t("dettaglio_app.initial_page.show_other_versions")}
                        </Button>
                    </Col>
                </Row>
            )}

            <Modal
                open={open}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                footer={[
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => changeAppVersion()}
                        disabled={!newVersion || newVersion.value === actualVersion.value}>
                        {t("dettaglio_app.initial_page.change_version")}
                    </Button>,
                ]}>
                {versions.map((version) => {
                    return (
                        <Col style={{ padding: "15px" }}>
                            <Card
                                onClick={() => {
                                    setNewVersion(version);
                                }}
                                style={{
                                    backgroundColor:
                                        version?.value === newVersion?.value
                                            ? "#5f4dee"
                                            : "#fafafa",
                                    color:
                                        version?.value === newVersion?.value ? "#fafafa" : "black",
                                    cursor: "pointer",
                                    textAlign: "center",
                                }}>
                                <b> {version?.label}</b>

                                <br />
                                {t(`apps.${userApp.technology}.resources.${version.value}`)}
                                <br />
                                {numeral(version?.price / 100).format("0,0.00") +
                                    ` (1 ${t("create_app.month")})`}
                            </Card>
                        </Col>
                    );
                })}
            </Modal>
        </>
    );
};

const InitialPage = ({ userApp, appName, getData, setUser }) => {
    const { t } = useTranslation();

    if (!userApp) return;

    const updateRenewal = (status) => {
        HTTPClient.post("/stripe/update_renewal", { app_name: appName, status })
            .then((res) => {
                getData();
                message.success(t("dettaglio_app.initial_page.renewal_success"));
            })
            .catch((e) => {
                message.error(t("dettaglio_app.initial_page.renewal_ko"));
            });
    };

    const updateFreeRenewal = () => {
        HTTPClient.post("/app/renew_free_tier", { appname: appName })
            .then((res) => {
                getData();
                message.success(t("dettaglio_app.initial_page.renewal_free_success"));
            })
            .catch((e) => {
                message.error(t("dettaglio_app.initial_page.renewal_free_ko"));
            });
    };

    return (
        <>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text style={{ fontWeight: "bold" }}>
                    {t("dettaglio_app.initial_page.buyed_version")}
                </Typography.Text>
            </Row>
            <AvailableVersions userApp={userApp} />

            {userApp.active ? (
                <>
                    <Row style={{ width: "100%", marginTop: "10px" }}>
                        <Typography.Text>
                            {userApp?.automatic_renewal
                                ? t("dettaglio_app.initial_page.automatic_renewal_expiration")
                                : t("dettaglio_app.initial_page.app_expiration")}
                            {moment(userApp?.expiration_date).format("DD/MM/YYYY")}.
                        </Typography.Text>
                    </Row>
                    {userApp?.resource_id === "free" ? (
                        <Row style={{ width: "100%", marginTop: "10px" }}>
                            <Popconfirm
                                title={t("dettaglio_app.initial_page.pop_confirm")}
                                onConfirm={() => updateFreeRenewal()}
                                okText={t("dettaglio_app.initial_page.pop_confirm_ok")}
                                cancelText="No">
                                <Button type="primary">
                                    {t("dettaglio_app.initial_page.renewal_app")}
                                </Button>
                            </Popconfirm>
                        </Row>
                    ) : (
                        <Row
                            style={{
                                width: "100%",
                                marginTop: "10px",
                                display: "flex",
                                gap: "10px",
                            }}>
                            <Button
                                type="primary"
                                danger={userApp?.automatic_renewal}
                                disabled={!userApp?.active}
                                onClick={() => updateRenewal(!userApp?.automatic_renewal)}>
                                {userApp?.automatic_renewal
                                    ? t("dettaglio_app.initial_page.disable_auto_renewal")
                                    : t("dettaglio_app.initial_page.enable_auto_renewal")}
                            </Button>
                        </Row>
                    )}
                </>
            ) : (
                <Row style={{ width: "100%", marginTop: "10px" }}>
                    <Typography.Text>{t("dettaglio_app.initial_page.expired")}</Typography.Text>
                </Row>
            )}
        </>
    );
};

export { InitialPage };
